// extracted by mini-css-extract-plugin
export default {"body":"invigilationLog_body__ppUFJ","full":"invigilationLog_full__0qHxn"};